/** Detect if URL is a video (for rendering video vs img) */
export function isVideoUrl(url: string): boolean {
  if (!url) return false;
  const lower = url.toLowerCase();
  return (
    lower.includes('post-videos') ||
    /\.(mp4|webm|mov|ogg)(\?|$)/.test(lower)
  );
}
